import { Component, Input, Output, EventEmitter, OnChanges, OnInit } from '@angular/core';
import { ActionButton, ActionButtonPosition, ActionButtonType, DisabledActionButton } from './action-button.model';
import { IColumn } from '../../common/interfaces/IColumn.interface';
import { MatDialog } from '@angular/material/dialog';
import { CpqColumnSelectionDialogComponent } from '../../dialogs/cpq-column-selection-dialog/cpq-column-selection-dialog.component';

@Component({
    selector: 'action-buttons',
    templateUrl: './action-buttons.component.html',
    styleUrls: ['./action-buttons.component.scss'],
    standalone: false
})
export class ActionButtonsComponent implements OnChanges {

  constructor(public dialog: MatDialog) { }

  @Input('actionButtons') actionButtons: Array<ActionButton>;
  @Input('columns') columns: Array<IColumn>;
  @Input('showColumnSelection') showColumnSelection: boolean = true;
  @Input('hideColumnSearchFunctionality') hideColumnSearchFunctionality: boolean = true;
  @Input('columnSearchActive') columnSearchActive: boolean;
  @Output('onColumnsChange') onColumnsChange = new EventEmitter<Array<IColumn>>();
  @Output('onHideColumnSearchFunctionalityChange') onHideColumnSearchFunctionalityChange = new EventEmitter();

  public ActionButtonType = ActionButtonType;
  public leftGroupButtons: Array<DisabledActionButton>;
  public rightGroupButtons: Array<DisabledActionButton>;
  public displayColumns: Array<IColumn>;

  ngOnChanges() {
    if (this.actionButtons) {
      this.validateActionButtons();
      this.leftGroupButtons = this.actionButtons.filter(button => button.position === ActionButtonPosition.Left || !button.position);
      this.rightGroupButtons = this.actionButtons.filter(button => button.position === ActionButtonPosition.Right);
      this.initButtons();
    }

    if (this.columns) {
      this.displayColumns = this.columns.filter(column => {
        if (!column.hidden) {
          return column;
        }
      });
    }
  }

  public selectColumns() {
    const dialogRef = this.dialog.open(CpqColumnSelectionDialogComponent, {
      data: {
        columns: this.displayColumns
      },
      minWidth: '500px',
      maxWidth: '100%'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.onColumnsChange.emit(result);
      }
    });
  }

  public toggleColumnSearchFields() {
    this.onHideColumnSearchFunctionalityChange.emit();
  }

  public initButtons(){
    this.hideButtons();
    this.disableButtons();
  }

  private disableButtons() {
    if (this.leftGroupButtons) {
      this.leftGroupButtons.forEach(button => {
        if (button.disable) {
          button.isDisabled = button.disable();
        }
      });
    } 
    if (this.rightGroupButtons) {
      this.rightGroupButtons.forEach(button => {
        if (button.disable) {
          button.isDisabled = button.disable();
        }
      });
    }
  }

  private hideButtons() {
    if (this.leftGroupButtons) {
      this.leftGroupButtons.forEach(button => {
        if (button.hide)
        button.isHidden = button.hide();
      });
    } else if (this.rightGroupButtons) {
      this.rightGroupButtons.forEach(button => {
        if (button.hide)
        button.isHidden = button.hide();
      });
    }
  }

  private validateActionButtons() {
    if (this.actionButtons) {
      this.actionButtons.forEach(button => {
        if (button.click && button.url) {
          throw new Error(`Action button with ${button.key} has attached click action and url, which is not allowed`);
        }        
        if (button.type === this.ActionButtonType.MenuButtonPrimary && (button.click || button.url)) {
          throw new Error(`Action button of button menu type with ${button.key} has attached click or url, which is not allowed`);
        }
        if (button.type === this.ActionButtonType.MenuButtonSecondary && (button.click || button.url)) {
          throw new Error(`Action button of button menu type with ${button.key} has attached click or url, which is not allowed`);
        }
        if (button.type === this.ActionButtonType.Custom && !button.customTemplate) {
          throw new Error(`Action button which is type custom has to have the customTemplate property set`);
        }
      });
    }
  }
}
